import { Component, HostListener } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DriverRecordRequestService } from '../../../services/driverrecordrequest.service';
import { IWizard } from '../../../interfaces/iwizard';
import { WizardSteps } from '../../../interfaces/wizard-steps';
import { ActivatedRoute, Router } from '@angular/router';
import { DateTime } from 'luxon';

@Component({
    selector: 'email-info',
    templateUrl: './email.component.html',
    styleUrls: ['./email.component.scss'],
    standalone: false
})
export class EmailComponent {

     form!: FormGroup;
     public wizard!: IWizard;

     hasInvalidEmailError: boolean = false;
     hasEmailInUseError: boolean = false;
     hasEmailMismatchError: boolean = false;
     confirmEmail?: string = '';
     isVerifying: boolean = false;
     _step = 2;

     constructor (public service: DriverRecordRequestService, public _router: Router, private route: ActivatedRoute) {
          this.wizard = this.service.getWizard();
     }

     ngOnInit(): void {
          setTimeout(() => this.scrollToTop(), 500);

          // driver cannot edit email, skips this step
          if (this.service.isReorder()) {
               this._step = 1;
               this._router.navigateByUrl(this.wizard.continueLinkRoute(this._step));
          }

          if (this.service.isDriverRequestInitialized === false && this.service.loadFromLocal() === false) {
               this._router.navigateByUrl('/driver/1');
          }

          if (this.service.driverRequest.emailAddress && this.service.driverRequest.emailAddress.length > 0) {
               this.confirmEmail = this.service.driverRequest.emailAddress;
          }

          // Define inputs with validations 
          this.form = new FormGroup({
               email: new FormControl(this.service.driverRequest.emailAddress, [
                    Validators.required,
                    Validators.maxLength(100),
                    Validators.pattern(/^[-a-z0-9'!_-}{\'?]+(\.[-a-z0-9'!_-}{\'?]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_-]+\.)+[a-zA-Z]{2,}))$/i)
               ]),
               confirmEmailInput: new FormControl(this.confirmEmail, [
                    Validators.required,
                    Validators.maxLength(100),
                    Validators.pattern(/^[-a-z0-9'!_-}{\'?]+(\.[-a-z0-9'!_-}{\'?]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_-]+\.)+[a-zA-Z]{2,}))$/i)
               ])
          });
     }

     get email() { return this.form!.get('email'); }
     get confirmEmailInput() { return this.form!.get('confirmEmailInput'); }

     ngAfterViewInit() {
          this.emailChanged();
     }

     ngOnDestroy() {
          this.service.driverRequest.emailAddress = this.form.get('email')?.value;
          this.service.saveToLocal();
     }

     isEmailInUse(emailExists: boolean) {
          this.hasEmailInUseError = emailExists;
          this.isVerifying = false;
     }

     emailChanged() {
          this.checkForMatch();

          this.hasEmailInUseError = false;
          if (this.email && this.email.value && this.email.value.length > 0) {
               this.isVerifying = true;
               const emailExistsPromise = this.service.doesEmailExist(this.email.value);
               emailExistsPromise.then((v: boolean) => this.isEmailInUse(v));
          } 
     }

     confirmEmailChanged() {
          this.checkForMatch();
     }

     checkForMatch() {
          this.hasEmailMismatchError = false;
          if (this.email?.value && this.confirmEmailInput?.value && this.confirmEmailInput.value.length > 0) {
               if (this.form.get('email')?.value === this.confirmEmailInput.value) {
                    this.hasEmailMismatchError = false;
               } else {
                    this.hasEmailMismatchError = true;
               }
          }
     }

     pageValid(): boolean {
          let hasError = true;
          if (this.email?.value && this.email.value.length > 0 &&
               this.confirmEmailInput?.value && this.confirmEmailInput.value.length > 0 &&
               this.hasInvalidEmailError === false &&
               this.hasEmailMismatchError === false &&
               this.hasEmailInUseError === false &&
               this.isVerifying === false) {
               hasError = false;
               this.service.driverRequest.emailAddress = this.email.value;
          }

          return hasError === false;
     }

     moveNext() {
          this._router.navigateByUrl('/driver/5');
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     @HostListener('window:beforeunload', ['$event'])
     unloadMessage($event: { returnValue: string; }) {
          return $event.returnValue = 'Your changes will not be saved';
     }
}
